module.exports = __webpack_public_path__ + "static/media/Nicole Reppert Headshot.8aa43441.png";